import React from "react";
import { LogoCloud } from "../../../components/ui/logo-cloud-4";

const cn = (...classes) => classes.filter(Boolean).join(" ");

const logos = [
  {
    src: "https://cdn.21st.dev/assets/mirror/e8/e8514b1206f79e1abdafcc1d2632393cc7cfbcbbe25426ac5143b17b184b56b8.svg",
    alt: "Claude AI Logo",
  },
  {
    src: "https://cdn.21st.dev/assets/mirror/56/5624b7c243ac8d60e848fb5ea222ec932c1600df54a2762238b37498372fb0c8.svg",
    alt: "Vercel Logo",
  },
  {
    src: "https://cdn.21st.dev/assets/mirror/90/90f01a9537335666282ae5acc80bd4305f86d085a92d60904c3aa3ccc4414570.svg",
    alt: "GitHub Logo",
  },
  {
    src: "https://cdn.21st.dev/assets/mirror/2b/2bcdd4124223e3bf8e66bc08ce0ac32a6cc42ffe3584bbecfd377847176a188d.svg",
    alt: "OpenAI Logo",
  },
    {
    src: "https://pub-b365ff8e20e448c3a7257b35173d9a38.r2.dev/mockups%20nesolearn/logos/7071f532-ec7a-47f6-85a0-2721ce1c6be6_removalai_preview.png",
    alt: "Africa Web3 Institute Logo",
    className: "pointer-events-none h-8 select-none md:h-10",
  },
  {
    src: "https://pub-b365ff8e20e448c3a7257b35173d9a38.r2.dev/mockups%20nesolearn/logos/daf9fad1-7763-434e-8a4b-8bfda6c3555f_removalai_preview.png",
    alt: "Nesolearn Logo",
  },
];

export default function LogoCloudSection() {
  return (
        <div className="relative w-full px-4 py-12 md:py-16">
      <div
        aria-hidden="true"
        className={cn(
          "-top-1/2 -translate-x-1/2 pointer-events-none absolute left-1/2 h-[120vmin] w-[120vmin] rounded-b-full",
          "bg-[radial-gradient(ellipse_at_center,--theme(--color-foreground/.1),transparent_50%)]",
          "blur-[30px]"
        )}
      />
      <div className="w-full">
                        <h2 className="mb-4 text-center">
          <span className="block font-medium text-sm text-muted-foreground md:text-base">
            The technology and partners behind Nesolearn
          </span>
          <span className="font-semibold text-base text-primary tracking-tight md:text-lg">
            Built on trusted infrastructure. Backed by real partnerships.
          </span>
        </h2>
        <LogoCloud logos={logos} />
      </div>
    </div>
  );
}